// extracted by mini-css-extract-plugin
export var dropdown = "_rn-0";
export var imageWrapper = "_rn-3";
export var itemNameContainer = "_rn-1";
export var productImage = "_rn-2";
export var spinnerWrapper = "_rn-4";